/** Catálogos de pantalla del CV. No son reglas de concurso; validación ANID pendiente. */

export const TIPOS_ANTECEDENTE_ACADEMICO = [
  'Pregrado',
  'Magister',
  'Doctorado',
  'Postitulo',
  'Especializacion',
];

export const INSTITUCIONES_CV = [
  'Universidad de Chile',
  'Universidad de Concepcion',
  'Universidad de Santiago de Chile',
  'Universidad Tecnologica Metropolitana',
  'Centro de Innovacion Aplicada',
  'Consorcio de Investigacion Aplicada',
  'Ministerio de Ciencia',
  'Academia Nacional de Ciencias',
  'Otra',
];

export const PAISES_CV = ['Chile', 'Argentina', 'Bolivia', 'Peru', 'Otro'];

export const DISCIPLINAS_AREA_CV = [
  'Ciencias Naturales',
  'Ingenieria y Tecnologia',
  'Ciencias Medicas y de la Salud',
  'Ciencias Agricolas',
  'Ciencias Sociales',
  'Humanidades',
];

export const EXPERIENCIA_VIGENTE_CV = ['Si', 'No'];

export const FUENTES_FINANCIAMIENTO_CV = ['ANID', 'FONDECYT', 'FONDEF', 'Otra'];

export const ROLES_PROYECTO_CV = [
  'Investigador principal',
  'Co-investigador',
  'Director de Proyecto',
];

export const TIPOS_PUBLICACION_CV = ['Paper', 'Articulo', 'Capitulo', 'Libro', 'Otra'];

export const ESTRUCTURAS_AUTORES_CV = [
  'Primer autor',
  'Autor de correspondencia',
  'Coautor',
];

export const NOMBRES_RECONOCIMIENTO_CV = [
  'Premio a la Innovacion Publica',
  'Reconocimiento a la trayectoria cientifica',
  'Otra',
];
